import { Component, Injector, OnInit } from '@angular/core';
import { ApiService } from '@api/api.service';
import { Invoice } from '@api/types';
import { ActionTrigger, RowsActions } from '@shared/table/actions/action';
import { TableConfig } from '@shared/types/table';
import * as FileSaver from 'file-saver';
import { InvoicesDataSource } from './invoices.datasource';

@Component({
  selector: 'rav-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss']
})
export class InvoicesComponent implements OnInit {
  tableConfig: TableConfig;
  dataSource: InvoicesDataSource;
  api: ApiService;

  constructor(public injector: Injector) {
    this.api = injector.get(ApiService);
    this.dataSource = new InvoicesDataSource(injector);
    this.tableConfig = {
      columns: [
        { key: 'invoice_number', action: RowsActions.downloadInvoicePdf },
        { key: 'created_at' },
        { key: 'total' }
      ],
      mobileSettings: {
        titleKeys: ['invoice_number'],
        subtitleKey: 'created_at',
        subtitleHeader: 'Created'
      }
    };
  }

  ngOnInit() {}

  async onActionsTriggered(trigger: ActionTrigger<Invoice>) {
    switch (trigger.name) {
      case 'Download PDF':
        const invoice = trigger.data[0];
        FileSaver.saveAs(await this.api.invoices.byId.download.get(invoice.id).toPromise());
    }
  }
}
